export default "__VITE_ASSET__B8Tva5fP__"